import * as React from 'react';
import { Component } from 'react';
import { ParentsDeliverySettings } from '../../models/generalMessage';

interface Props {
  parentsDeliverySettings: ParentsDeliverySettings;
  onDeliverySettingsChanged: (settings: ParentsDeliverySettings) => void;
  disabled: boolean;
}

interface State {
  parentsDeliverySettings: ParentsDeliverySettings;
}

enum PRIORITIES {
  FIRST_ONLY = 'FIRST_ONLY',
  SECOND_ONLY = 'SECOND_ONLY',
  THIRD_ONLY = 'THIRD_ONLY'
}

export class GeneralMessagesSettingFormPriorities extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      parentsDeliverySettings: { ...props.parentsDeliverySettings }
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.parentsDeliverySettings !== this.props.parentsDeliverySettings) {
      this.setState({ parentsDeliverySettings: { ...this.props.parentsDeliverySettings } });
    }
  }

  onAllParentsCheckedChange = () => {
    const newSettings = {
      all: true,
      firstPriority: false,
      secondPriority: false,
      thirdPriority: false
    };

    this.onDeliverySettingsChanged(newSettings);
  };

  onPrioritiesCheckedChange = (priority: PRIORITIES) => {
    const { parentsDeliverySettings } = this.state;
    const newSettings = {
      ...parentsDeliverySettings,
      all: false
    };

    switch (priority) {
      case PRIORITIES.FIRST_ONLY:
        newSettings.firstPriority = !parentsDeliverySettings.firstPriority;
        break;
      case PRIORITIES.SECOND_ONLY:
        newSettings.secondPriority = !parentsDeliverySettings.secondPriority;
        break;
      case PRIORITIES.THIRD_ONLY:
        newSettings.thirdPriority = !parentsDeliverySettings.thirdPriority;
        break;
    }

    if (!newSettings.firstPriority && !newSettings.secondPriority && !newSettings.thirdPriority) {
      newSettings.all = true;
    }

    this.onDeliverySettingsChanged(newSettings);
  };

  onDeliverySettingsChanged = newSettings => {
    this.setState({ parentsDeliverySettings: newSettings });
    this.props.onDeliverySettingsChanged(newSettings);
  };

  renderPriorityButton(key: string, title: string, checked: boolean, disabled: boolean, onClick: () => void) {
    return (
      <button
        key={key}
        type="button"
        className={`gmPriority ${checked ? 'gmPriority--active' : ''}`}
        disabled={disabled}
        onClick={onClick}
      >
        <span className="gmPriority__check">✓</span>
        <strong>{title}</strong>
      </button>
    );
  }

  render() {
    const { all, firstPriority, secondPriority, thirdPriority } = this.state.parentsDeliverySettings;
    const { disabled } = this.props;

    return (
      <section className={`gmSettings__section gmPriorities ${disabled ? 'gmPriorities--disabled' : ''}`}>
        <div className="gmSettings__sectionHead">
          <h4>Parent priorities</h4>
        </div>
        <div className="gmPriorities__grid">
          {this.renderPriorityButton('all', 'All parents', all, disabled, this.onAllParentsCheckedChange)}
          {this.renderPriorityButton('first', 'Priority 1', firstPriority, disabled, () =>
            this.onPrioritiesCheckedChange(PRIORITIES.FIRST_ONLY)
          )}
          {this.renderPriorityButton('second', 'Priority 2', secondPriority, disabled, () =>
            this.onPrioritiesCheckedChange(PRIORITIES.SECOND_ONLY)
          )}
          {this.renderPriorityButton('third', 'Priority 3', thirdPriority, disabled, () =>
            this.onPrioritiesCheckedChange(PRIORITIES.THIRD_ONLY)
          )}
        </div>
      </section>
    );
  }
}
